module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_7005.887a7408.png";